// @ts-nocheck
import PropTypes from 'prop-types';

export default PropTypes.shape({
  id: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
});

export const VideoResource = PropTypes.shape({
  ad: PropTypes.shape({
    context: PropTypes.string,
    showPrerollOnNonZeroStart: PropTypes.bool,
  }),
  playback: PropTypes.shape({
    startTime: PropTypes.number,
  }),
});
